/**
 * Google Ads Conversion Tracking Utility
 * ----------------------------------------
 * Tag ID: AW-18057162120
 *
 * HOW TO ADD REAL CONVERSION LABELS:
 * 1. Go to Google Ads → Goals → Conversions → New conversion action
 * 2. Choose "Website" → enter your site URL
 * 3. Create one action called "WhatsApp Click" and one called "Quote Form Submit"
 * 4. After saving, click the action → "Tag setup" → "Use Google Tag Manager"
 * 5. Copy the label (looks like: AbCdEfGhIjKlMnOpQrSt12)
 * 6. Paste it in CONVERSION_LABELS below, replacing the placeholder strings
 */

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export const GTAG_ID = 'AW-18057162120';

// ⬇️  Replace these with real labels from Google Ads once you create the conversion actions
const CONVERSION_LABELS: Record<string, string> = {
  WHATSAPP_CLICK: 'REPLACE_WITH_WHATSAPP_LABEL',
  QUOTE_FORM_SUBMIT: 'MA6BCLuN7ZMcEIjbqaJD',
};

function gtagReady(): boolean {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

/**
 * Fire a Google Ads conversion event.
 * `value` is optional — set it if you want to assign a monetary value to the conversion.
 */
export function trackConversion(
  action: keyof typeof CONVERSION_LABELS,
  value?: number
): void {
  if (!gtagReady()) return;

  const label = CONVERSION_LABELS[action];

  // Skip firing if the label hasn't been set yet (still a placeholder)
  if (label.startsWith('REPLACE_WITH')) {
    // Still fire a named event so you can verify in GA4 / Tag Assistant
    window.gtag('event', action === 'WHATSAPP_CLICK' ? 'whatsapp_click' : 'generate_lead', {
      event_category: 'engagement',
      event_label: action,
    });
    return;
  }

  // Use provided value or default to 1.0 for QUOTE_FORM_SUBMIT
  const conversionValue = value !== undefined ? value : (action === 'QUOTE_FORM_SUBMIT' ? 1.0 : undefined);

  window.gtag('event', 'conversion', {
    send_to: `${GTAG_ID}/${label}`,
    ...(conversionValue !== undefined ? { value: conversionValue, currency: 'USD' } : {}),
  });

  // Also fire a named event for GA4 / debugging visibility
  window.gtag('event', action === 'WHATSAPP_CLICK' ? 'whatsapp_click' : 'generate_lead', {
    event_category: 'engagement',
  });
}
